import type { LimitStatus } from '@growup/arena-shared';
import { StatusBadge } from '@growup/ui';

import { formatMinutes, LIMIT_LOOK, limitLabel } from '../format';

/** Where a youth stands against the limits: symbol, words and colour together. */
export function LimitBadge({ status }: { status: LimitStatus }) {
  const look = LIMIT_LOOK[status.state];
  return (
    <StatusBadge tone={look.tone} symbol={look.symbol}>
      {limitLabel(status)}
    </StatusBadge>
  );
}

export function LimitSummary({ status }: { status: LimitStatus }) {
  return (
    <p className="text-caption text-gu-ink-muted">
      Hoje {formatMinutes(status.playedTodayMinutes)} de {formatMinutes(status.dailyLimitMinutes)} ·
      seguida {formatMinutes(status.continuousMinutes)} de{' '}
      {formatMinutes(status.continuousLimitMinutes)}
    </p>
  );
}
